import { useState } from 'react'
import { showAlertError } from 'src/components/alertError'
import KeyboardPressPasswordEletronic from 'src/components/keyPressPasswordeletronic'
import { ModalLoader } from 'src/components/modalLoader'
import { OTPInput } from 'src/components/OTPInput'
import { useAuth } from 'src/hooks/auth'
import { api } from 'src/services/api'
import { isAxiosError } from 'src/utils/isAxiosError'
import { setAuthToken } from 'src/utils/setAuthToken'
import type { BeneficiaryDataProps, NewPixFormProps } from '.'

interface PasswordStepProps extends NewPixFormProps {
  beneficiaryData: BeneficiaryDataProps
  amount: number
  setTransaction?: any
}

export function PasswordStep({
  nextStep,
  beneficiaryData,
  amount,
  setTransaction,
}: PasswordStepProps) {
  const [clickedValues, setClickedValues] = useState<string[]>([])
  const [isSubmiting, setIsSubmiting] = useState(false)

  const { account, user } = useAuth()

  const updatePassword = (value: string) => {}

  const handleKeyPress = (value: string) => {}

  const handleConfirm = async (value: string[]) => {
    setIsSubmiting(true)

    try {
      setAuthToken()

      if (user.role === 'ADMIN_BAG') {
        const response = await api.post(
          '/pix/payment/admin',
          {
            key: beneficiaryData.key,
            keyType: beneficiaryData.keyType,
            endToEndId: beneficiaryData.endToEndId,
            beneficiaryName: beneficiaryData.name,
            beneficiaryDocument: beneficiaryData.beneficiaryDocument,
            amount,
          },
          {
            params: {
              security_key: value.join(''),
            },
          }
        )
        if (setTransaction) setTransaction(response.data)
      } else {
        const response = await api.post(
          '/pix/payment',
          {
            key: beneficiaryData.key,
            keyType: beneficiaryData.keyType,
            endToEndId: beneficiaryData.endToEndId,
            accountId: account.virtual_account_id,
            beneficiaryName: beneficiaryData.name,
            beneficiaryDocument: beneficiaryData.beneficiaryDocument,
            amount,
          },
          {
            params: {
              security_key: value.join(''),
            },
          }
        )
        if (setTransaction) setTransaction(response.data)
      }

      nextStep()
    } catch (error) {
      console.log('porra', error)
      if (isAxiosError(error) && error.response) {
        const errorMessage = (error.response.data as { error: string }).error
        showAlertError(errorMessage)
      } else {
        showAlertError('Ocorreu um erro inesperado.')
      }
    } finally {
      setIsSubmiting(false)
    }
  }

  if (isSubmiting) {
    return <ModalLoader />
  }

  return (
    <>
      <div className="flex flex-col items-center">
        <p className="text-[1.875rem] font-semibold text-center">
          Insira a sua senha eletrônica de <br /> 8 dígitos para confirmar a
          ação:
        </p>
        <OTPInput length={8} formData={clickedValues} />
        <KeyboardPressPasswordEletronic
          onKeyPress={handleKeyPress}
          onConfirm={handleConfirm}
          updateParentInput={updatePassword}
          updateClickedValues={(values: string[]) => setClickedValues(values)}
        />
      </div>
    </>
  )
}
